import Box from '@risk-smart/themed-cloudscape-components/box';
import { LayoutLeft } from '@untitled-ui/icons-react';
import type { FC } from 'react';

import Logo from './Logo';
import { NavItems } from './NavItems';
import type { Props } from './types';

const Navigation: FC<Props> = ({
  navigationOpen,
  setNavigationOpen,
  navItems,
  renderCount,
}) => {
  const gradientStyle =
    'sticky left-0 right-0 h-7 pointer-events-none z-[1000] -mb-5';

  return (
    <Box>
      <div
        data-testid={'navigation'}
        className={'transition-all duration-300 bg-navy_mid relative z-[1100]'}
      >
        <div
          className={`transition-all duration-300 overflow-hidden truncate bg-navy_mid h-full text-white text-[14px] font-semibold flex flex-col relative w-full`}
        >
          <div
            className={
              'flex h-[52px] bg-navy_mid border-0 border-b border-solid border-navy_light sticky z-20 justify-between items-center top-0 px-5'
            }
          >
            {navigationOpen ? (
              <>
                <Logo small={!navigationOpen} />
                {/*
                  Icon-only, so the accessible name has to come from `aria-label`.
                  It matters more than it looks: collapsing the nav is what makes the
                  app usable at narrow widths (the shell holds a 250px nav down to
                  390px), and until now the control announced as an unnamed button.
                */}
                <button
                  onClick={() => setNavigationOpen(!navigationOpen)}
                  aria-label={'Collapse navigation'}
                  aria-expanded={true}
                  className={
                    'transition bg-transparent opacity-80 hover:opacity-100 border-0 text-white flex items-center justify-center text-center p-1 rounded-md cursor-pointer size-9 rs-nav-button flex-shrink-0'
                  }
                >
                  <LayoutLeft />
                </button>
              </>
            ) : (
              <button
                className={
                  'flex items-center justify-center mt-[2px] ml-[2px] bg-transparent border-0 text-grey500 text-center rounded-md cursor-pointer'
                }
                onClick={() => setNavigationOpen(!navigationOpen)}
                aria-label={'Expand navigation'}
                aria-expanded={false}
              >
                <Logo small={true} />
              </button>
            )}
          </div>

          <div
            id={'nav-items-container'}
            className={'h-lvh overflow-y-auto no-scrollbar relative'}
          >
            <ul
              className={
                'flex flex-col items-start list-none py-3 px-0 m-0 mb-[100px]'
              }
            >
              <NavItems
                items={navItems}
                renderCount={renderCount}
                collapsed={!navigationOpen}
              />
            </ul>

            <div
              className={`${gradientStyle} from-navy_mid to-transparent  bottom-[53px] bg-gradient-to-t -mt-7`}
            />
          </div>
        </div>
      </div>
    </Box>
  );
};

export default Navigation;
